module.exports = __webpack_public_path__ + "static/media/icon-pause.11d5aef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/icon-pause.png
// module id = 1885
// module chunks = 6